import { render, staticRenderFns } from "./creditList.vue?vue&type=template&id=0fa68697&scoped=true"
import script from "./creditList.vue?vue&type=script&lang=js"
export * from "./creditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa68697",
  null
  
)

export default component.exports